import {AsyncInlineError} from '@s-ui/decorators'
import {Service} from '@s-ui/domain'

import {GenericUserError} from '../../user/Errors/GenericUserError.js'
import {GetUserAdsError} from '../Errors/GetUserAdsError.js'
import {HTTPUserAdsRepository} from '../Repositories/HTTPUserAdsRepository.js'

export class GetUserAdsService extends Service {
  #config
  #genericUserError
  #getUserAdsError
  #repository

  static create({config}) {
    return new GetUserAdsService({config})
  }

  constructor({config}) {
    super()
    this.#config = config
    this.#genericUserError = GenericUserError
    this.#getUserAdsError = GetUserAdsError
    this.#repository = HTTPUserAdsRepository.create({
      config: this.#config
    })
  }

  @AsyncInlineError()
  async execute({userEntity}) {
    if (!userEntity)
      return Promise.reject(this.#genericUserError.create({message: '[GetUserAdsService#execute] User must be logged'}))

    const [getUserAdsError, userAdsListVO] = await this.#repository.getUserAds({
      userEntity
    })

    if (getUserAdsError) return Promise.reject(this.#getUserAdsError.create({message: getUserAdsError.toJSON()}))

    return userAdsListVO
  }
}
